import { useEffect, useRef, useState } from "react";
import { getPublicTiktokOembed } from "@/lib/api";

/**
 * Perfil/creador TikTok vía oEmbed (proxy /api/public/tiktok-oembed) + embed.js
 */
export default function TikTokCreatorEmbed({ url, className = "" }) {
  const [html, setHtml] = useState("");
  const [err, setErr] = useState(false);
  const hostRef = useRef(null);

  useEffect(() => {
    let alive = true;
    setHtml("");
    setErr(false);
    (async () => {
      try {
        const data = await getPublicTiktokOembed(url);
        if (!alive) return;
        if (data?.html) setHtml(String(data.html));
        else setErr(true);
      } catch (_) {
        if (alive) setErr(true);
      }
    })();
    return () => {
      alive = false;
    };
  }, [url]);

  useEffect(() => {
    if (!html) return;
    if (document.querySelector("script[data-onboarding-tiktok-embed]")) return;
    const s = document.createElement("script");
    s.src = "https://www.tiktok.com/embed.js";
    s.async = true;
    s.dataset.onboardingTiktokEmbed = "1";
    document.body.appendChild(s);
  }, [html]);

  if (err) {
    return (
      <p className={`ob-canvas-small text-neutral-400 px-2 text-center leading-snug ${className}`}>
        No se pudo cargar el perfil. Comprueba que la URL sea pública (p. ej. https://www.tiktok.com/@usuario).
      </p>
    );
  }
  if (!html) {
    return (
      <div className={`flex items-center justify-center ob-canvas-small text-neutral-400 ${className}`}>Cargando perfil TikTok…</div>
    );
  }
  return (
    <div
      ref={hostRef}
      className={`tiktok-oembed-host w-full min-h-0 overflow-auto flex justify-center ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
